import { create } from 'zustand';
import { AssetSource } from '@/models/asset';
import { Entity } from '@/models/subscription-topic';
import { AssetUploader } from '@/upload/assset-uploader';
import { RecordingUploader } from '@/upload/recording-uploader';
import { type StageType, UploadStages } from '@/upload/upload-types';

export interface UploadState {
    init: (entity: Entity | undefined, entityId: string) => void;
    entity?: Entity;
    entityId?: string;
    source?: AssetSource;
    uploader?: AssetUploader | RecordingUploader;
    setFileUploader: (uploader: AssetUploader) => void;
    setRecordingUploader: (uploader: RecordingUploader) => void;
    stage: StageType;
    setStage: (stage: StageType) => void;
}

export const useUpload = create<UploadState>((set) => ({
    init: (entity: Entity | undefined, entityId: string) => set(() => ({ entity: entity, entityId: entityId, uploader: undefined, stage: UploadStages.PREPARING })),
    entity: undefined,
    entityId: undefined,
    source: undefined,
    stage: UploadStages.PREPARING,
    uploader: undefined,
    setFileUploader: (uploader: AssetUploader) => set(() => ({uploader: uploader, source: AssetSource.UPLOAD })),
    setRecordingUploader: (uploader: RecordingUploader) => set(() => ({uploader: uploader, source: AssetSource.RECORD })),
    setStage: (stage: StageType) => set(() => ({ stage: stage }))
}));
